import Routes from "./routes";
export default Routes;
export * from "./interfaces";
export * from "./AccountRoutes";
export * from "./PartnerRoutes";
export * from "./routes";
